// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3ffxF","bigColWidth":"Table_bigColWidth__1pFZ2","biggerColWidth":"Table_biggerColWidth__1y18H","row":"Table_row__FDKMe","col":"Table_col__olNI7"};